const ElementoAer = (props) => {

    const formato = 'text-center'

    const asistentes = [
  {cartel: 'Titular de Farmacia', valor: 'TIT'},
  {cartel: 'Empleado de Farmacia', valor: 'EMP'},
  {cartel: 'Expositor', valor: 'EXP'},
  {cartel: 'Staff Drogueria', valor: 'SDR'},
  {cartel: 'Estudiante', valor: 'EST'},
  {cartel: 'Invitado (Acompañante)', valor: 'INV'}
]

    const t_asist = (a) => {
        return asistentes.find(e => e.valor===a).cartel
    }

    return (<>
        <div className="w-full flex bg-zinc-200 flex-row justify-between"  onClick={e => props.setUpdData(props.obj)} key={props.obj.id}>
            <input 
                type="checkbox" 
                id={props.obj.id}  
                checked={props.obj.s}
                onChange={(e => props.elegir(props.obj.id))}
            />
             <div className="px-5 grid grid-cols-9 w-full">
              <label>{props.obj.apellido===props.obj.apellido.substring(0,13) ? props.obj.apellido : props.obj.apellido.substring(0,13) + '...'}</label>
              <label>{props.obj.nombre}</label>
              <label className="col-span-2">{props.obj.email.substring(0,30)===props.obj.email ? props.obj.email : props.obj.email.substring(0,30) + '...'}</label>
              <label>{props.obj.documento}</label>
              <label>{props.obj.telefono}</label>

                <label>{t_asist(props.obj.asistente)}</label>
              <label className={formato}>{props.evento.prefijoqr + props.obj.id.toString().padStart(parseInt(props.evento.cifrasqr),'0')}</label>
              <label>{props.obj.enteraste}</label>
            </div>
        </div>
        </>)
}

export default ElementoAer